module.exports = __webpack_public_path__ + "static/gods-debris-82b2169016beb57feb0abb6be39a1b7f.jpg";